import { UtmParams } from '../user/user';

export enum AuthErrorCode {
  OAuthOnlyAccount = 'oauth_only_account',
}

export type RegisterRequest = {
  email: string;
  password: string;
  userAgent?: string;
  utm?: UtmParams;
  clickId?: string;
} & MetaPixelParams;

export type LoginRequest = {
  email: string;
  password: string;
  utm?: UtmParams;
  clickId?: string;
} & MetaPixelParams;

export type SsoRequest = {
  token: string;
  utm?: UtmParams;
  clickId?: string;
} & MetaPixelParams;

export type MetaPixelParams = {
  fbp?: string;
  fbc?: string;
};

export type UserMetadataParams = {
  ip?: string;
  userAgent?: string;
};

export type RegisterMetadata = MetaPixelParams &
  UserMetadataParams & { utm?: UtmParams };
